import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getGestorOperacoes,
    getVendedorAgencia,    
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import buscarLocalizacaoVeiculo from '../../actions/veiculo/buscarLocalizacaoVeiculo';
import $ from 'jquery';
import iconeQrCode from '../../img/codigo-qr.png'
import iconeTransferencia from '../../img/transferindo.png'
import iconeEncomenda from '../../img/icone-encomenda.png';
import iconeCash from '../../img/cash-coin.svg'
import { ativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import buscarPrecosRota from '../../actions/preco/buscarPrecosRota';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import { ativarVendaSite } from '../../actions/itinerario/ativarOuInativarVendaSite'
import { ativarHorarioExtra, inativarHorarioExtra } from '../../actions/itinerario/ativarOuInativarHorarioExtra'
import { EMPRESA_POLITUR, listaTipoPrecos, tipoCategoria } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';
import iconAudoria from  '../../img/auditoria.png';
import iconHistoricoTransferencia from '../../img/transferencia-de-passageiros.png';
import buscarUltimosHistoricosItinerario from '../../actions/itinerario/buscarUltimosHistoricosItinerario';
import buscarHistoricosTransferenciaPassageiros from '../../actions/itinerario/buscarHistoricosTransferenciaPassageiros';

export class Itinerario extends React.Component {

    selecionarItinerario(itinerario) {
        this.props.changeFieldValue('formularioCadastroItinerario',
            'idItinerario', itinerario.id);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'dataPartida', moment(itinerario.dataPartida)
                .toDate());
        this.props.changeFieldValue('formularioCadastroItinerario',
            'horaSaida', itinerario.horaSaida);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'assentosDisponiveis', itinerario.assentosDisponiveis);

        if (itinerario.tipoPreco) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoPrecoPrimeiroAndar', {
                label: itinerario.tipoPreco.descricaoTipoPreco,
                value: itinerario.tipoPreco.tipoPreco
            });
        }

        if(itinerario.descontoMaximo !== null){
            this.props.changeFieldValue('formularioCadastroItinerario',
            'descontoMaximo', itinerario.descontoMaximo);

        }

        this.props.changeFieldValue('formularioCadastroItinerario',
            'horarioExtra', itinerario.horarioExtra);

        if (itinerario.tipoAjusteItinerario !== null) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoAjusteItinerario', {
                label: itinerario.tipoAjusteItinerario.descricao,
                value: itinerario.tipoAjusteItinerario.nameEnum
            });
            if (itinerario.tipoConfiguracaoPreco) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'tipoConfiguracaoPreco', {
                    label: itinerario.tipoConfiguracaoPreco.descricao,
                    value: itinerario.tipoConfiguracaoPreco.valor
                });
            }            
            if (itinerario.valorAjuste != null) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'exibirAjuste', true);
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'valorAjuste', itinerario.valorAjuste ? itinerario.valorAjuste : '00.00');

            }            
            if (itinerario.horaPartidaRegra != null) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'horaPartidaRegra', itinerario.horaPartidaRegra);
            }
            this.props.changeFieldValue('formularioCadastroItinerario',
                'quantidadePoltronasRegra', itinerario.quantidadePoltronasRegra);

            
        }

        if (itinerario.tipoConfiguracaoPrecoPrioritario != null && itinerario.pricePorUsuario && itinerario.pricePorUsuario.length) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoConfiguracaoPrecoPrioritario', {
                label: itinerario.tipoConfiguracaoPrecoPrioritario.descricao,
                value: itinerario.tipoConfiguracaoPrecoPrioritario.valor
            });            
            if (itinerario.tipoConfiguracaoPrecoPrioritario.valor === 'POR_USUARIO') {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'exibirAjustePrioritario', true);                

            }
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoConfiguracaoPrecoPrioritario', {
                label: itinerario.tipoConfiguracaoPrecoPrioritario.descricao,
                value: itinerario.tipoConfiguracaoPrecoPrioritario.valor
            });
            
            if (itinerario.pricePorUsuario != null && itinerario.tipoConfiguracaoPrecoPrioritario.valor === 'POR_USUARIO') {
                this.props.preencherPricePorUsuario(itinerario.pricePorUsuario.map(it => {
                    const vendedor = this.props.usuariosVendedores.find(v => v.chave == it.usuarioId)
                    return {
                        id: it.usuarioId,
                        tipoAjusteItinerario: {label: it.tipoAjusteItinerario.descricao, value: it.tipoAjusteItinerario.nameEnum},
                        valorAjuste: it.valorAjuste,
                        vendedor: {label: vendedor.valor, value: vendedor.chave }
                    }
                }));

            }
        }

        if (itinerario.pricePorCategoria && itinerario.pricePorCategoria.length) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'exibirAjustePorCategoria', true);
            this.props.preencherPricePorCategoria(itinerario.pricePorCategoria.map(it => {
                const tipoPreco = this.props.tiposPreco
                    ? this.props.tiposPreco.find(tp => tp.tipoPreco === it.tipoPreco)
                    : null;
                return {
                    tipoPreco: it.tipoPreco,
                    descricao: tipoPreco ? tipoPreco.descricaoTipoPreco : it.tipoPreco,
                    tipoAjusteItinerario: {label: it.tipoAjusteItinerario.descricao, value: it.tipoAjusteItinerario.nameEnum},
                    valorAjuste: it.valorAjuste,
                };
            }));
        }

        if (itinerario.prestador) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'prestador', {
                label: itinerario.prestador.valor,
                value: itinerario.prestador.chave
            });
        } else {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'prestador', {
                label: 'Frota própria',
                value: null
            });
        }



        this.props.changeFieldValue('formularioCadastroItinerario',
            'veiculo', {
            label: `${itinerario.veiculoDto.descricao}`,
            value: itinerario.veiculoDto
        });
        this.props.changeFieldValue('formularioCadastroItinerario',
            'habilitadoSite', itinerario.habilitadoSite);

        this.props.preencherModalEdicao(this.props.itinerario);
        this.props.selecionarItinerario(this.props.itinerario);

    }

    selecionarItinerarioAlterarVeiculo(itinerario) {
        this.props.selecionarItinerario(this.props.itinerario);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'idItinerario', itinerario.id);
        this.props.changeFieldValue('formularioAlterarVeiculoItinerario',
            'veiculo', {
            label: `${itinerario.veiculoDto.descricao}`,
            value: itinerario.veiculoDto
        });
        if (itinerario.veiculoDto.seDoisAndares) {
            this.props.changeFieldValue('formularioAlterarVeiculoItinerario',
                'andar', {
                label: `${itinerario.andar === 1 ? '1º Andar' : '2º Andar'}`,
                value: itinerario.andar
            })
        }
    }

    ativarOuInativar = (e) => {
        const idItinerario = this.props.itinerario.id;
        const idEmpresa = this.props.itinerario.idEmpresa;
        if (e.target.value != 'false') {
            this.props.itinerarioChecked(idItinerario);
            $('#modalConfirmacaoInativacaoItinerario').modal({
                show: true
            });
        } else {
            this.props.ativarItinerario(idEmpresa, idItinerario)
                .then(() => {
                    this.props.buscarItinerarios();
                });
        }
    }

    exibeAtivo = () => {
        return (
            <input type="checkbox" data-target="#modalConfirmacaoInativacaoItinerario" value={this.props.itinerario.ativo} checked={this.props.itinerario.ativo} onChange={this.ativarOuInativar} />
        );
    }

    exibirStatus() {
        if (this.props.itinerario.ativo) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    ativarOuInativarVendaSite = (e) => {
        const idItinerario = this.props.itinerario.id;
        const idEmpresa = this.props.itinerario.idEmpresa;
        if (e.target.value != 'false') {
            this.props.itinerarioChecked(idItinerario);
            $('#modalConfirmacaoInativacaoVendaSite').modal({
                show: true
            });
        } else {
            this.props.ativarVendaSite(idEmpresa, idItinerario)
                .then(() => {
                    this.props.buscarItinerarios();
                });
        }
    }

    exibeAtivoVendaSite = () => {
        return (
            <input type="checkbox" data-target="#modalConfirmacaoInativacaoVendaSite" value={this.props.itinerario.habilitadoSite} checked={this.props.itinerario.habilitadoSite} onChange={this.ativarOuInativarVendaSite} />
        );
    }

    exibirStatusVendaSite() {
        if (this.props.itinerario.habilitadoSite) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    ativarOuInativarHorarioExtra = (e) => {
        const idItinerario = this.props.itinerario.id;
        const idEmpresa = this.props.itinerario.idEmpresa;
        const acao = e.target.checked ? this.props.ativarHorarioExtra : this.props.inativarHorarioExtra;
        acao(idEmpresa, idItinerario)
            .then(() => {
                this.props.buscarItinerarios();
            });
    }

    exibeHorarioExtra = () => {
        return (
            <input type="checkbox" checked={this.props.itinerario.horarioExtra} onChange={this.ativarOuInativarHorarioExtra} />
        );
    }

    exibirStatusHorarioExtra() {
        if (this.props.itinerario.horarioExtra) {
            return (<span className="txt-ativo">Sim</span>);
        }
        return (<span className="txt-inativo">Não</span>);
    }

    buscarLocalizacao() {
        this.props.buscarLocalizacaoVeiculo(this.props.itinerario.veiculoDto.id, this.props.itinerario.idEmpresa).then(() => {
            $('#modalLocalizacaoVeiculo')
                .modal('show');
        })
    }

    buscarPrecosRota() {
        if (tipoCategoria.mista.valor == this.props.itinerario.tipoCategoria) {            
            const tipoPrecos = this.retornaPrecosItinerarioMisto(this.props.itinerario);
            this.props.buscarPrecosRota(this.props.itinerario.idEmpresa, this.props.itinerario.rotaDto.id, tipoPrecos);
        } else {
            this.props.buscarPrecosRota(this.props.itinerario.idEmpresa, this.props.itinerario.rotaDto.id, [this.props.itinerario.tipoPreco.tipoPreco])
        }
    }

    retornaPrecosItinerarioMisto(itinerario) {
        const poltronas = itinerario.poltronas;
        const tipoPrecos = [...new Set(poltronas.map(it => it.tipoPreco))];
        return tipoPrecos;
    }

    categoriasItinerario(itinerario) {
        const tipoPrecos = this.retornaPrecosItinerarioMisto(itinerario);
        let tipos = '';
        tipoPrecos.forEach((it, index) => {
            const item = listaTipoPrecos.filter(l => l.id == it);            
            if (item && item.length > 0) {
                tipos += `${index > 0 ? ' | ' : ''} ${item[0].descricao}`
            }
        })
        return tipos
        
    }

    exibirIconeItinerarioMisto(itinerario) {
        return <> {this.props.itinerario.tipoCategoria} <span className="align-self-center tooltip-info">
            <a data-tip data-for={`categoria-${itinerario.id}`}>
                <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
            </a>
            <div className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id={`categoria-${itinerario.id}`}
                    type="dark" effect="solid">
                    <div className="row">{this.categoriasItinerario(itinerario)}</div>
                </ReactTooltip>
            </div>
        </span></>
    }

    naoEhPerfilVendedor() {
        return !validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
    }

    exibirListaPassageiro() {
        if (!this.props.empresaSelecionada.habilitadoBloqueioListaPassageiro) {
            const url = `/painel-lista-passageiros?itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`;
            if (this.props.empresaSelecionada.id === EMPRESA_POLITUR) {
                return this.naoEhPerfilVendedor() ? (
                    <button type="button" className="dropdown-item vx-action-item"
                        onClick={() => this.props.history.push(url)}>
                        <i className="material-icons">people</i> Lista de Passageiros
                    </button>
                ) : null;
            }
            return (
                <button type="button" className="dropdown-item vx-action-item"
                    onClick={() => this.props.history.push(url)}>
                    <i className="material-icons">people</i> Lista de Passageiros
                </button>
            );
        }
        return null;
    }

    render() {
        const it = this.props.itinerario;
        const empresa = this.props.empresaSelecionada;
        const habilitadoSite = empresa.habilitadoSite;
        const tipo = this.props.isEdicao ? '' : '&tipo=embarque';
        const gridClass = `vx-gp-row-main vx-gp-row-main--itinerario${habilitadoSite ? '-site' : ''}`;

        return (
            <div className="vx-gp-row">
                <div className={gridClass}>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Data/Hora Saída</span>
                        <span className="vx-gp-field-value"><Moment format="DD/MM/YYYY">{it.dataPartida}</Moment></span>
                        <span className="vx-gp-field-sub">{it.horaSaida}</span>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Assentos</span>
                        <span className="vx-gp-field-value">{it.assentosDisponiveis}</span>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Veículo</span>
                        <span className="vx-gp-field-value">{it.veiculoDto.descricao}</span>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Rota</span>
                        <span className="vx-gp-field-value">
                            {it.rotaDto.cidadeOrigem.nome}-{it.rotaDto.cidadeOrigem.uf} → {it.rotaDto.cidadeDestino.nome}-{it.rotaDto.cidadeDestino.uf}
                        </span>
                        {it.rotaDto.prefixo && <span className="vx-gp-field-sub">{it.rotaDto.prefixo}</span>}
                        <span className="vx-gp-field-sub"><strong>ID Rota: {it.rotaDto.id} · ID Itin.: {it.id}</strong></span>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Prestador</span>
                        <span className="vx-gp-field-value">{it.prestador ? it.prestador.valor : 'Frota própria'}</span>
                    </div>

                    {habilitadoSite && (
                        <div className="vx-gp-field">
                            <span className="vx-gp-field-label">Venda Site</span>
                            <div className="custom-btn-status exibeAtivo" htmlFor={it.id}>
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    {this.exibeAtivoVendaSite()}
                                </Autorizacao>
                                {this.exibirStatusVendaSite()}
                            </div>
                        </div>
                    )}

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Categorias</span>
                        <span className="vx-gp-field-value">
                            {it.tipoPreco ? it.tipoPreco.descricaoTipoPreco : this.exibirIconeItinerarioMisto(it)}
                        </span>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Horário Extra</span>
                        <div className="custom-btn-status exibeAtivo" htmlFor={it.id}>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getGestorEmpresa(it.idEmpresa),
                                getGestorOperacoes(it.idEmpresa),
                                getAdminEmpresa(it.idEmpresa),
                                getOperadorEmpresa(it.idEmpresa)]}>
                                {this.exibeHorarioExtra()}
                            </Autorizacao>
                            {this.exibirStatusHorarioExtra()}
                        </div>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Ativo/Inativo</span>
                        <div className="custom-btn-status exibeAtivo" htmlFor={it.id}>
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getGestorEmpresa(it.idEmpresa),
                                getGestorOperacoes(it.idEmpresa),
                                getAdminEmpresa(it.idEmpresa),
                                getOperadorEmpresa(it.idEmpresa)]}>
                                {this.exibeAtivo()}
                            </Autorizacao>
                            {this.exibirStatus()}
                        </div>
                    </div>

                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">QR Embarque</span>
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getGestorEmpresa(it.idEmpresa),
                            getGestorOperacoes(it.idEmpresa),
                            getAdminEmpresa(it.idEmpresa),
                            getOperadorEmpresa(it.idEmpresa),
                            getFiscalEmbarque(it.idEmpresa)]}>
                            {it.sePodeEmbarcar ?
                                <img style={{ cursor: 'pointer', width: '28px' }} title="Embarcar com QrCode"
                                    src={iconeQrCode}
                                    onClick={() => this.props.history.push('/painel-embarque-com-qrcode?itinerario=' + it.id)} />
                                : <span style={{ fontSize: '11px', color: '#999' }}>Fora do período</span>}
                        </Autorizacao>
                    </div>

                    <div className="vx-gp-field">
                        <div className="dropdown">
                            <button className="vx-actions-trigger" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">more_vert</i>
                            </button>
                            <div className="dropdown-menu vx-actions-menu">

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        data-toggle="modal" data-target="#modalCadastrarItinerario"
                                        onClick={() => this.selecionarItinerario(it)}>
                                        <i className="material-icons">edit</i> Editar Itinerário
                                    </button>
                                </Autorizacao>

                                {this.exibirListaPassageiro()}

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getAdminEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getOperadorRemarcacao(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        onClick={() => this.props.history.push(`/painel-transferencia-passageiros?itinerario=${it.id}${tipo}`)}>
                                        <img src={iconeTransferencia} width={16} height={16} alt="" /> Transferir Passageiros
                                    </button>
                                </Autorizacao>

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa),
                                    getFiscalEmbarque(it.idEmpresa),
                                    getMotoristaEmpresa(it.idEmpresa)]}>
                                    <Link to={`/painel-recibos-itinerario?empresa=${empresa.id}&itinerario=${it.id}${tipo}`}
                                        target="_blank" className="dropdown-item vx-action-item">
                                        <i className="material-icons">receipt</i> Recibos do Itinerário
                                    </Link>
                                </Autorizacao>

                                <button type="button" className="dropdown-item vx-action-item"
                                    onClick={() => this.props.history.push(`/mapa-viagem-itinerario?itinerario=${it.id}${tipo}`)}>
                                    <i className="material-icons">map</i> Mapa de Viagem
                                </button>

                                {!empresa.habilitadoBuscaReservaComBpe && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(it.idEmpresa),
                                        getGestorOperacoes(it.idEmpresa),
                                        getAdminEmpresa(it.idEmpresa),
                                        getOperadorEmpresa(it.idEmpresa)]}>
                                        <button type="button" className="dropdown-item vx-action-item"
                                            onClick={() => this.props.history.push(`/painel-bloqueio-poltronas?itinerario=${it.id}`)}>
                                            <i className="material-icons">event_seat</i> Bloqueio de Poltronas
                                        </button>
                                    </Autorizacao>
                                )}

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        data-toggle="modal" data-target="#modalAlterarVeiculoItinerario"
                                        onClick={() => this.selecionarItinerarioAlterarVeiculo(it)}>
                                        <i className="material-icons">directions_bus</i> Alterar Veículo
                                    </button>
                                </Autorizacao>

                                {!empresa.habilitadoBuscaReservaComBpe && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(it.idEmpresa),
                                        getAdminEmpresa(it.idEmpresa),
                                        getMotoristaEmpresa(it.idEmpresa),
                                        getFiscalEmbarque(it.idEmpresa),
                                        getOperadorEmpresa(it.idEmpresa)]}>
                                        <button type="button" className="dropdown-item vx-action-item"
                                            onClick={() => this.props.history.push(`/painel-detalhamento-financeiro-itinerario?itinerario=${it.id}`)}>
                                            <i className="material-icons">attach_money</i> Detalhamento Financeiro
                                        </button>
                                    </Autorizacao>
                                )}

                                {!empresa.habilitadoBuscaReservaComBpe && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(it.idEmpresa),
                                        getGestorOperacoes(it.idEmpresa),
                                        getAdminEmpresa(it.idEmpresa),
                                        getMotoristaEmpresa(it.idEmpresa),
                                        getFiscalEmbarque(it.idEmpresa),
                                        getOperadorEmpresa(it.idEmpresa)]}>
                                        <button type="button" className="dropdown-item vx-action-item"
                                            onClick={() => {
                                                this.selecionarItinerario(it);
                                                this.props.history.push(`/painel-detalhamento-financeiro-itinerario-Encomenda?itinerario=${it.id}`);
                                            }}>
                                            <img src={iconeEncomenda} width={16} height={16} alt="" /> Financeiro Encomenda
                                        </button>
                                    </Autorizacao>
                                )}

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        data-toggle="modal" data-target="#modalPrecosRota"
                                        onClick={() => this.buscarPrecosRota()}>
                                        <img src={iconeCash} width={16} height={16} alt="" /> Relação de Valores da Rota
                                    </button>
                                </Autorizacao>

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorOperacoes(empresa.id),
                                    getAdminEmpresa(empresa.id)]}>
                                    <Link to={`/painel-configuracao-reserva-bpe?codigoItinerario=${it.id}&paginaRetorno=${this.props.paginaRetorno}`}
                                        className="dropdown-item vx-action-item"
                                        onClick={() => this.selecionarItinerario(it)}>
                                        <i className="material-icons">settings</i> Configuração BPe
                                    </Link>
                                </Autorizacao>

                                {it.veiculoDto && it.veiculoDto.idRastreamento && (
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(it.idEmpresa),
                                        getGestorOperacoes(it.idEmpresa),
                                        getAdminEmpresa(it.idEmpresa),
                                        getOperadorEmpresa(it.idEmpresa)]}>
                                        <button type="button" className="dropdown-item vx-action-item"
                                            onClick={() => this.buscarLocalizacao()}>
                                            <i className="material-icons">location_on</i> Localização do Itinerário
                                        </button>
                                    </Autorizacao>
                                )}

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getMotoristaEmpresa(it.idEmpresa),
                                    getFiscalEmbarque(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        data-toggle="modal" data-target="#modalHistoricoItinerario"
                                        onClick={() => {
                                            this.props.selecionarItinerario(it);
                                            this.props.buscarUltimosHistoricosItinerario(it.id, empresa.id);
                                        }}>
                                        <img src={iconAudoria} width={16} height={16} alt="" /> Históricos Itinerário
                                    </button>
                                </Autorizacao>

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getAdminEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getOperadorRemarcacao(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item"
                                        data-toggle="modal" data-target="#modalHistoricoTransferenciaPassageiro"
                                        onClick={() => {
                                            this.props.selecionarItinerario(it);
                                            this.props.buscarHistoricosTransferenciaPassageiros(it.id, empresa.id);
                                        }}>
                                        <img src={iconHistoricoTransferencia} width={16} height={16} alt="" /> Históricos Transferências
                                    </button>
                                </Autorizacao>

                                <div className="dropdown-divider"></div>

                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getGestorEmpresa(it.idEmpresa),
                                    getGestorOperacoes(it.idEmpresa),
                                    getAdminEmpresa(it.idEmpresa),
                                    getMotoristaEmpresa(it.idEmpresa),
                                    getFiscalEmbarque(it.idEmpresa),
                                    getOperadorEmpresa(it.idEmpresa)]}>
                                    <button type="button" className="dropdown-item vx-action-item vx-action-item--danger"
                                        data-toggle="modal" data-target="#modalConfirmacaoExclusaoItinerario"
                                        onClick={() => this.selecionarItinerario(it)}>
                                        <i className="material-icons">delete</i> Excluir Itinerário
                                    </button>
                                </Autorizacao>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        usuariosVendedores: state.usuariosVendedores,
        tiposPreco: state.tiposPreco,
    }
}

export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    selecionarItinerario,
    buscarReservasItinerario,
    buscarLocalizacaoVeiculo,
    ativarItinerario,
    buscarPrecosRota,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    ativarVendaSite,
    ativarHorarioExtra,
    inativarHorarioExtra,
    buscarUltimosHistoricosItinerario,
    buscarHistoricosTransferenciaPassageiros
})(reduxForm({
    form: 'formularioItinerario'
})(Itinerario)))
